import { AxiosInstance } from "axios";
import { HttpHelper } from "../../../../Core/Http/HttpHelper";
import { AuthResponse, LeadToLive } from "../../../../Model/CommonModel";
import { SystemCore } from "../../../../Core/System/SystemCore";
import { ISessionStateContext } from "../../../../Core/State/SessionStateContext";
import { NavigateFunction } from "react-router-dom";

export class SoSmartMicrosoftLogin {
    private client: AxiosInstance = HttpHelper.buildAxiosInstance();

    private _baseUri: string = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize";
    private _clientId: string = "46dd81d5-9a3d-4b14-8ecb-3d1812a62027";
    private _responseType: string = "code";
    private _responseMode: string = "query";

    private _prompt: string;
    private _redirectUri: string;
    private _loginHint: string;
    private _scopes: string[];
    private _state: string;

    constructor(redirectUri?: string, prompt?: string, loginHint?: string, scopes?: string[], state?: string) {
        this._redirectUri = redirectUri!;

        this._prompt = prompt!;
        this._loginHint = loginHint!;
        this._scopes = scopes!;
        this._state = state!;
    }

    private buildUrl(): string {
        return `${this._baseUri}?client_id=${this._clientId}&response_type=${this._responseType}&response_mode=${this._responseMode}&prompt=${this._prompt}&redirect_uri=${this._redirectUri}&login_hint=${this._loginHint}&scope=${this._scopes.join(" ")}&state=${this._state}`;
    }

    public runLoginMicrosoft() {
        try {
            window.open(this.buildUrl(), "_self");
        } catch (error) {
            console.error(error);
        }
    }

    public validateMicrosoftLogin(redirectUri: string, code: string, state: string): Promise<AuthResponse> {
        return new Promise<AuthResponse>((resolve, reject) => {
            if(!code || !state) {
                reject(true);
                return;
            }

            this.client.get("/api/setup/microsoft/tenant/getinfo?code=" +code + "&state=" + state + "&redirectUri="+redirectUri).then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.response.data);
            });
        });
    }

    public static changePrivateUserToMsUser(context: ISessionStateContext, navigate: NavigateFunction, leadToLive: LeadToLive) {
        const systemCore: SystemCore = new SystemCore();
        const redirectUrl: string = btoa(window.location.pathname);
        const suggestedEmail: string = btoa(leadToLive.adminUser.userPrincipleName);

        let additionalParams: string = `?resource=${redirectUrl}&email=${suggestedEmail}`;

        systemCore.logOutUser(context, navigate, additionalParams);
    }
}